import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'components/InputField/SelectField';
import DateRangeField from 'components/InputField/DateRangeField';
import CountyInput from 'containers/Input/CountyInput';

const labels = {
  register_from: 'Registered from',
  register_to: 'To',
  logged_from: 'Logged from',
  logged_to: 'To',
};

function Filters({
  onDateRangeChange,
  onChangeQuery,
  query,
  roles
}) {
  return (
    <div className="container_admin_user">
      <DateRangeField
        onChange={onDateRangeChange}
        fromValue={query.register_from}
        toValue={query.register_to}
        fieldName={'register'}
        className="calendar_picker"
        labels={labels}
      />
      <DateRangeField
        onChange={onDateRangeChange}
        fromValue={query.logged_from}
        toValue={query.logged_to}
        fieldName={'logged'}
        className="calendar_picker"
        labels={labels}
      />
      <div className='user-type-filter'>
        <SelectField
          className='col s4'
          label='User Type'
          onChange={(e) => onChangeQuery('user_type', e.target.value)}
          field_name='user_type'
          value={query.user_type || ''}
          options={roles}
        />
        <i onClick={(e) => onChangeQuery('user_type', '')} className="material-icons icon_close">close</i>
      </div>
      <div className='user-type-filter'>
        <CountyInput
          label={<div style={{marginBottom: '11px'}}></div>}
          value={query['county']}
          onChange={(e) => onChangeQuery('county', e.value)}
        />
        <i onClick={(e) => onChangeQuery('county', null)} className="material-icons icon_close">close</i>
      </div>

      <div className='col s2 search_admin' style={{width: '74px'}}>
        <input id="search" type="submit" className="validate" />
        <label htmlFor="search">
          <i className="material-icons icon_search">search</i>
        </label>
        <input
          type="search"
          placeholder="Hospital"
          value={query.hospital}
          onChange={(e) => onChangeQuery('hospital', e.target.value)} />
            <i onClick={(e) => onChangeQuery('hospital', '')} className="material-icons icon_close">close</i>
      </div>
    </div>
  );
}

Filters.defaultProps = {};

Filters.propTypes = {};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Admin/Statistics/Toolbar/Filters.jsx